import { create } from 'zustand';

export type SettingsTab =
  | 'general'
  | 'companyProfiles'
  | 'customerTypes'
  | 'invoicing'
  | 'contracts'
  | 'localEnvironment'
  | 'payments'
  | 'integrations'
  | 'avi'
  | 'localization';

interface SettingsViewStore {
  activeTab: SettingsTab;
  selectedCompanyProfileId: string | null;
  selectedCustomerCategoryId: string | null;
  setActiveTab: (value: SettingsTab) => void;
  setSelectedCompanyProfileId: (value: string | null) => void;
  setSelectedCustomerCategoryId: (value: string | null) => void;
}

export const useSettingsViewStore = create<SettingsViewStore>((set) => ({
  activeTab: 'general',
  selectedCompanyProfileId: null,
  selectedCustomerCategoryId: null,
  setActiveTab: (activeTab) => set({ activeTab }),
  setSelectedCompanyProfileId: (selectedCompanyProfileId) => set({ selectedCompanyProfileId }),
  setSelectedCustomerCategoryId: (selectedCustomerCategoryId) => set({ selectedCustomerCategoryId })
}));
